<template>
  <div id="invoice-page">
    <div class="flex flex-wrap items-center justify-between">
      <h3 class="mb-base mr-3">Contrat Client</h3>
      <div class="flex items-center">
        <vs-button
          class="mb-base mr-3"
          type="border"
          icon-pack="feather"
          icon="icon icon-download"
          >Download</vs-button
        >
        <vs-button
          class="mb-base mr-3"
          icon-pack="feather"
          icon="icon icon-file"
          @click="printInvoice"
          >Print</vs-button
        >
      </div>
    </div>

    <vx-card id="invoice-container">
      <div class="vx-row leading-loose px-base pt-2 pb-2">
        <div class="vx-col w-1/2 mt-base">
          <img
            src="@/assets/images/logo/logo_original.png"
            alt="casatroc-logo"
            class="w-1/3"
          />
        </div>
        <div class="vx-col w-1/2 text-right">
          <h4>ACTE DE DÉPOT</h4>
          <div class="invoice__invoice-detail mt-4">
            <h6>Tunis, le {{ new Date(Date.now()) | date(true) }}.</h6>
          </div>
        </div>
        <div class="vx-col w-1/2 mt-6">
          <h6 class="text-base">Client {{ client.ref }}</h6>
          <div class="invoice__recipient-info my-0">
            <p class="text-xs">{{ client.full_name }}</p>
          </div>
          <div class="invoice__recipient-contact">
            <p class="text-xs flex items-center">
              <feather-icon
                icon="PhoneIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              <span class="ml-2">{{ client.phone_number }}</span>
            </p>
          </div>
        </div>
        <div class="vx-col w-1/2 text-right mt-6">
          <h6 class="text-base">Casa Troc</h6>
          <div class="invoice__company-info my-0">
            <p class="text-xs">Av de Palestine, Lot n31, Ain Zaghouan Nord</p>
          </div>
          <div class="invoice__company-contact">
            <p class="text-xs flex items-center justify-end">
              <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
              <span class="ml-2">zekrimolk@gmail.com</span>
            </p>
            <p class="text-xs flex items-center justify-end">
              <feather-icon
                icon="PhoneIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              <span class="ml-2">53 135 526 - 53 301 549</span>
            </p>
          </div>
        </div>
      </div>

      <div class="text-sm leading-relaxed px-base py-2">
        <p v-if="client.cin === '-'">
          Je soussignée {{ client.full_name }}, titulaire de la CIN n°:
          ...................................., déclare avoir déposé auprès de
          Casa Troc le(s) article(s) décrit(s) ci-dessous:
        </p>
        <p v-else>
          Je soussignée {{ client.full_name }}, titulaire de la CIN n°:
          {{ client.cin }}, déclare avoir déposé auprès de Casa Troc le(s)
          article(s) décrit(s) ci-dessous:
        </p>
      </div>

      <div class="px-base">
        <vs-table hoverFlat :data="products">
          <template slot="thead">
            <vs-th class="text-xs">REF</vs-th>
            <vs-th class="text-xs">PRODUIT</vs-th>
            <vs-th class="text-xs">EN MAIN</vs-th>
            <vs-th class="text-xs">VALIDITÉ</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="(product, index) in data" :key="index">
              <vs-td class="text-xs py-0" :data="product.ref">{{
                product.ref
              }}</vs-td>
              <vs-td class="text-xs py-0" :data="product.name">{{
                product.name
              }}</vs-td>
              <vs-td class="text-xs py-0" :data="product.client_price"
                >{{ product.client_price }} TND</vs-td
              >
              <vs-td class="text-xs py-0" :data="data[index].validity"
                >{{ data[index].validity }} jours</vs-td
              >
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <div class="px-base p-2">
        <p class="text-sm leading-relaxed pb-2">
          J'atteste par le présent document que les produits sus-indiqués
          m'appartiennent (non volés et non empruntés) et qu'ils ne sont pas
          issus de la contrefaçon. A défaut, je prends entièrement la
          responsabilité que ce soit auprès de CASA TROC ou auprès des tiers.
        </p>
        <p class="text-sm leading-relaxed">
          Par le présent acte, j'autorise CASA TROC à vendre le(s) bien(s)
          ci-dessus au(x) prix indiqué(s) et à percevoir une commission convenue
          de qui en sera déduite. Cet engagement est valable pendant la période
          de dépôt indiquée ci-dessus.
        </p>
        <p class="text-sm leading-relaxed pb-2">
          Durant cette période, si je souhaite mettre fin au présent engagement
          en récupérant un ou plusieurs ou la totalité des articles déposés, je
          reconnais devoir au préalable indemniser CASA TROC en lui versant le
          montant des commissions qui auraient été perçues par la vente de cet
          (ces) article(s).
        </p>
        <p class="text-sm leading-relaxed">
          Aussi, je déclare bénéficier d'un délai de 5 jours, à compter de la
          fin de la période de dépôt, pour récupérer les articles qui n'ont pas
          été vendus.
        </p>
        <p class="text-sm leading-relaxed">
          Passé ce délai, je désengage CASA TROC de toute responsabilité et je
          reconnais perdre tout droit sur les biens non repris.
        </p>
        <p class="text-sm leading-relaxed pb-2 font-bold">
          Passé le délai de récupération, tout article déposé n’est plus 
          sous notre responsabilité et sera automatiquement donné, 
          sans aucun recours ni réclamation possible.
        </p>
        <p class="text-sm leading-relaxed">
          N.B: CASA TROC se réserve le droit de retirer sans préavis un article
          de la vente en cas de défaut non signalé lors du dépôt. Les articles
          déposés ne font pas tous l'objet d'une diffusion sur les réseaux
          sociaux.
        </p>
      </div>
      <div class="vx-row px-base pb-base">
        <div class="vx-col w-1/2 text-center justify-center">
          <div class="invoice__recipient-info my-2">
            <p class="text-sm">CACHET DU DÉPOSITAIRE</p>
            <p class="text-sm text-bold">CASA TROC</p>
          </div>
        </div>
        <div class="vx-col w-1/2 text-center justify-center">
          <div class="invoice__company-info my-2">
            <p class="text-sm">SIGNATURE, "Bon pour accord"</p>
            <p class="text-sm text-bold">{{ client.full_name }}</p>
          </div>
        </div>
      </div>
      <div class="flex flex-col text-center items-center py-base">
        <p class="text-sm mb-4">
          Le déposant peut suivre la vente de ses articles via le lien suivant:
        </p>
        <img
          height="70"
          width="70"
          :src="`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://casatroc.tn/clientspace/${client._id}`"
        />
        <p class="text-xs mt-4">
          https://casatroc.tn/clientspace/{{ client._id }}
        </p>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mailTo: "",
    };
  },
  props: {
    products: {
      required: true,
    },
    client: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  methods: {
    printInvoice() {
      const style = document.createElement("style");
      style.id = "contract-print-settings";
      style.innerHTML = `
        @page { 
          size: A4; 
          margin: 10mm; 
        }
      `;
      document.head.appendChild(style);

      window.print();

      window.onafterprint = () => {
        const s = document.getElementById("contract-print-settings");
        if (s) s.remove();
      };
    },
  },
  components: {},
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  },
};
</script>

<style lang="scss">
@media print {
  * {
    visibility: hidden !important;
  }

  #content-area {
    margin: 0 !important;
  }

  #invoice-container,
  #invoice-container * {
    visibility: visible !important;
  }
  #invoice-container {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    box-shadow: none !important;
    font-size: 14px !important; // Base font size for print
    
    // Increase heading sizes
    h3, h4, h6 {
      font-size: 1.3em !important;
    }
    
    // Increase paragraph and text sizes
    p {
      font-size: 1.05em !important;
      line-height: 1.5 !important;
    }
    
    // Increase table text
    .text-xs {
      font-size: 0.9em !important;
    }
    
    .text-sm {
      font-size: 1.05em !important;
    }
    
    .text-base {
      font-size: 1.15em !important;
    }
    
    // Increase table header and cell sizes
    .vs-table {
      font-size: 0.95em !important;
      
      th, td {
        font-size: 0.95em !important;
        padding: 6px !important;
      }
    }
  }
}
</style>
